<template>
  <CareerIFrame :config="config" />
</template>

<script>
import CareerIFrame from "../../components/CareerIFrame/CareerIFrame.vue";

export default {
  name: "app",
  components: {
    CareerIFrame
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
